import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CurrencyFormatter } from '../../../../components/Formatters';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.toString().length > 0) {
    return value;
  } else {
    return "0.00";
  }
}

const TotalAmountPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{CurrencyFormatter(getValue(data.value))}</Col>
      </Row>
  ),
  id: 'totalAmountPropertyPlugin',
  title: 'Total Amount Property',
  description: 'Total Amount Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Total Amount',
        },
      },
      required: ['label'],
    },
  },
};

export default TotalAmountPropertyPlugin;